import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Checkbox, Radio } from 'semantic-ui-react';

import InputCounter from "../InputCounter/InputCounter";

import {
  setMessageName,
  setMessageText,
  setMessageType,
  toggleMessageClientsRole,
  toggleMessageConsultantsRole,
} from '../../../redux/actions/editMessage';

import "./MessageForm.scss";

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
  setMessageName: value => dispatch(setMessageName(value)),
  setMessageText: value => dispatch(setMessageText(value)), 
  setMessageType: (e, { value }) => dispatch(setMessageType(value)),
  toggleMessageClientsRole: () => dispatch(toggleMessageClientsRole()),
  toggleMessageConsultantsRole: () => dispatch(toggleMessageConsultantsRole()),
});

class MessageForm extends Component {
  static propTypes = {
    message: PropTypes.object.isRequired,
    submitText: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    edit: PropTypes.bool,
    setMessageName: PropTypes.func.isRequired,
    setMessageText: PropTypes.func.isRequired,
    setMessageType: PropTypes.func.isRequired,
    toggleMessageClientsRole: PropTypes.func.isRequired,
    toggleMessageConsultantsRole: PropTypes.func.isRequired,
  };

  static defaultProps = {
    edit: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      formWasSent: false,
      validationError: false,
    }
    //this.quillEditor = null;      // Quill instance
    //this.reactQuillRef = React.createRef(); // ReactQuill component
  }

  /*
  componentDidMount() {
    this.attachQuillRefs();
  }

  componentDidUpdate() {
    this.attachQuillRefs();
  }

  attachQuillRefs = () => {
    if (typeof this.reactQuillRef.current.getEditor !== 'function') return;
    this.quillEditor = this.reactQuillRef.current.getEditor();
  }
  */

  onSubmitForm = () => {
    const { onSubmit } = this.props;
    const validationError = this.validateForm();
    this.setState({ formWasSent: true });
    if (!validationError) onSubmit();
  }

  validateForm = () => {
    const { message } = this.props;
    //const quillTextLength = (this.quillEditor && this.quillEditor.getLength()) - 1;
    if (((message.title.length === 0) || (message.title.length > 50)) 
      //|| ((quillTextLength === 0) || (quillTextLength > 1000))) return true;
      || ((message.message.length === 0) || (message.message.length > 1000))) return true;
    return false;
  }

  render() {
    const {
      message,
      setMessageName,
      setMessageText,
      setMessageType,
      submitText,
      edit,
      toggleMessageClientsRole,
      toggleMessageConsultantsRole
    } = this.props;

    const { formWasSent } = this.state;

    const btnClass = classnames({
      'btn': true,
      'btn-green': true,
      'long': edit,
      'messages': !edit,
    });

    //Длина текста внутри ReactQuill
    //const quillTextLength = (this.quillEditor && this.quillEditor.getLength()) - 1;

    const msgTitleError = ((message.title.length === 0) || (message.title.length > 50));
    //const msgTextError = ((quillTextLength === 0) || (quillTextLength > 1000));
    const msgTextError = ((message.message.length === 0) || (message.message.length > 1000));

    const titleRowClass = classnames({
      'form-row': true,
      'error': formWasSent && msgTitleError,
    });

    const textRowClass = classnames({
      'form-row': true,
      'error': formWasSent && msgTextError,
    });

    let msgTitleErrorText = '';
    if (message.title.length === 0) msgTitleErrorText = 'Введите название сообщения';
    if (message.title.length > 50) msgTitleErrorText = 'Превышена максимальная длина названия сообщения';

    //Текст ошибки для текстового поля
    let msgTextErrorText = '';
    if (message.message.length === 0) msgTextErrorText = 'Введите текст сообщения';
    if (message.message.length > 1000) msgTextErrorText = 'Превышена максимальная длина текста сообщения'; 
    //if (quillTextLength === 0) msgTextErrorText = 'Введите текст сообщения';
    //if (quillTextLength > 1000) msgTextErrorText = 'Превышена максимальная длина текста сообщения';

    return (
      <div className="form-wrap message-form">
        <div className="form-row">
          <div className="radio-label">Тип сообщения</div>
          <div className="radio-wrap">
            <Radio
              label='Release notes'
              name='radioGroup'

              value='release'
              checked={message.type === 'release'}
              onChange={setMessageType}
            />
            <Radio
              label='Info'
              name='radioGroup'
              value='info'
              checked={message.type === 'info'}
              onChange={setMessageType}
            />
          </div>
        </div>
        {/* Название сообщения */}
        <div className={titleRowClass}>
          <InputCounter
            label="Название сообщения"
            value={message.title}
            onChange={(value) => setMessageName(value)}
            maxLength={50}
          />
          {(formWasSent && msgTitleError) ? (
            <div className="input-text">{msgTitleErrorText}</div>
          ) : false}
        </div>

        {/* Текст сообщения */}
        <div className={textRowClass}>
          {/*
          <div className="input-top">
            <label htmlFor="address">Текст сообщения</label>
            <div className="counter">{quillTextLength}/1000</div>
          </div>
          <ReactQuill
            value={message.message}
            onChange={setMessageText}
            ref={this.reactQuillRef}
          />
          */}
          <InputCounter
            isTextarea
            classNameText="long"
            label="Текст сообщения"
            value={message.message}
            onChange={(value) => setMessageText(value)}
            maxLength={1000}
          />
          {(formWasSent && msgTextError) ? (
            <div className="input-text">{msgTextErrorText}</div>
          ) : false}
        </div>

        {edit ? (
          /* Редактирование: отображение ролей сообщения */
          <div className="roles-block">
            {message.clients ? (
              <div className="role-item clients">Для клиентов</div>
            ) : false}
            {message.consultants ? (
              <div className="role-item consultants">Для консультантов</div>
            ) : false}
          </div>
        ) : ( 
          /* Создание: выбрать, для какой роли доступно сообщение */
          <div className="form-row special">
            <div className="checkboxes-wrap">
              <Checkbox
                label='Для клиентов'
                checked={message.clients}
                onChange={() => toggleMessageClientsRole()}
              />
              <Checkbox
                label='Для консультантов'
                checked={message.consultants}
                onChange={() => toggleMessageConsultantsRole()}
              />
            </div>
          </div>
        )}


        <div className="form-row special">
          <button
            type="button"
            className={btnClass}
            onClick={() => this.onSubmitForm()}
          >
            {submitText}
          </button>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageForm);
